export const PLAYBACK_MIN = 0.1;

export const PLAYBACK_MAX = 4;

export const PLAYBACK_DEFAULT = 1;

export const SKIP_VALUE_DEFAULT = 10;
